// login.component.ts
import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MsalModule } from '@azure/msal-angular';
import { AuthService } from '../../core/services/auth.service';
import { clearMSALInteractionState } from '@/app/core/utilities/utils';
import { Brand } from '@/app/consts/brand.config';
import { TegelModule } from '@scania/tegel-angular-17';
import { LanguageService, Language } from '../../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, MsalModule, TegelModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  authService = inject(AuthService);
  languageService = inject(LanguageService);
  isLoggingIn = false;

  currentLanguage = computed(() => this.languageService.currentLanguage());

  ngOninit(){
    this.authService.handleRedirectCallback();
  }

  async login(brand: Brand) {
    if(this.isLoggingIn) {
      alert('You are already logged in.');
      return;
    } 
    this.isLoggingIn = true;

    try{
      await this.authService.setAuthType(brand);
      const scopes = this.authService.getScopes();
      await this.authService.initialize();
      clearMSALInteractionState();
      const result = this.authService
        .loginRedirect({ scopes: scopes })
        .then(() => console.log('Redirect initiated'))
        .catch((err) => console.error('Redirect failed', err));
      console.log(result);
    } catch (error) {
      console.error('Login failed', error);
    } finally {
      this.isLoggingIn = false;
    }
  }

  logout() {
    this.authService.fullLogout();
  }

  switchLanguage(lang: Language) {
    this.languageService.setLanguage(lang);
  }
}
